import { AxiosResponse } from 'axios'
import { apiNode } from './api'
import { DefaultGetParamsProps } from './types/interfaces'
import {
	GetChatMessagesDataResponse,
	SendMessagesPostResponse,
	UpdateChatProps,
} from './types/chat.interfaces'

const URL = '2/chats'

export const ChatService = {
	async getChatMessages({
		id,
	}: DefaultGetParamsProps): Promise<GetChatMessagesDataResponse> {
		const response: AxiosResponse<GetChatMessagesDataResponse> =
			await apiNode.get(`${URL}/${id}`)
		return response?.data
	},
	async create({
		fileId,
		isTemporary,
		title,
	}: {
		fileId: string
		isTemporary: boolean
		title?: string
	}) {
		return await apiNode.post(`${URL}`, { fileId, title, isTemporary })
	},
	async delete({ id }: DefaultGetParamsProps) {
		return await apiNode.delete(`2/chats/${id}`)
	},
	async togglePinChat({
		id,
		isPinned,
		title,
	}: {
		id: string
		isPinned: boolean
		title?: string
	}) {
		return await apiNode.patch(`2/chats/${id}`, { isPinned, title })
	},
	async sendMessage({
		id,
		text,
	}: {
		id: string
		text: string
	}) {
		const response: AxiosResponse<SendMessagesPostResponse> =
			await apiNode.post<SendMessagesPostResponse>(`2/chats/${id}/messages`, {
				text,
			})
		return response?.data
	},

	async update({ id, data }: UpdateChatProps) {
		return await apiNode.patch(`${URL}/${id}`, data)
	},
}
